import service from "@/plugins/axios";
import store from "@/store";

const request = new service();
const source = "/api/";

export const GET_PROFILE_INFO = (): Promise<any[]> => {
  return request.axiosCall({
    method: `get`,
    url: `${source}` + "user/info/",
    headers: {
      Authorization: store.state.token,
    },
  });
};
